<template>
  <!-- Marketing pages bring their own navbar/footer + natural page scroll,
       so the bid_ui app header and the locked full-height shell are skipped. -->
  <div :class="{ 'marketing-shell': isMarketing }" style="display: contents;">
    <AppHeader v-if="isHeaderVisible && !isMarketing" :isLogin="isLogin" :userName="userName" />
    <router-view :headerVisiblity="headerVisiblity" :loginUser="loginUser" :getAccessToken="getAccessToken"></router-view>
    <!-- Shared confirmation dialog, opened with confirmAction() from utils/confirm.js -->
    <ConfirmDialog />
  </div>
</template>

<script>
import AppHeader from './components/Header.vue';
import ConfirmDialog from './components/ConfirmDialog.vue';
export default {
  name: 'App',
  components: {
    AppHeader,
    ConfirmDialog
  },
  data() {
    return {
      isHeaderVisible: true,
      isLogin: false,
      userName: this.getUserEmail()
    }

  },

  computed: {
    // Marketing (BidSnap AI) pages render in their own layout — no app
    // header, and the locked full-height/overflow-hidden shell is relaxed so
    // the page can scroll normally.
    isMarketing() {
      return this.$route.meta?.layout === 'marketing';
    }
  },

  watch: {
    isMarketing: {
      immediate: true,
      handler(val) {
        // bid_ui's base.css locks html/body/#app to height:100vh; overflow:hidden
        // (good for the fixed app shell, fatal for a scrolling marketing page).
        // Toggle a class on all three so the marketing pages can scroll.
        const app = document.getElementById('app');
        if (app) app.classList.toggle('marketing-mode', val);
        document.documentElement.classList.toggle('marketing-mode', val);
        document.body.classList.toggle('marketing-mode', val);
      }
    }
  },

  methods: {

    headerVisiblity: function (isHeaderVisible) {
      this.isHeaderVisible = isHeaderVisible;
    },
    loginUser: function (isLogin) {
      this.isLogin = isLogin;
    },

    getAccessToken: function () {
      const userInfo = localStorage.getItem('user-info');
      if (userInfo == null) {
        this.$router.push({ name: 'LoginPage' });
      } else {
        const userInfoObj = JSON.parse(userInfo);
        return userInfoObj.access_token;
      }
    },

    getUserEmail: function () {
      const userInfo = localStorage.getItem('user-info');
      if (userInfo) {
        try {
          const userObj = JSON.parse(userInfo);
          return userObj.email || userObj.username || 'User';
        } catch (e) {
          return 'User';
        }
      }
      return 'User';
    }

  }
};
</script>

<style>
#app {
  font-family: var(--font-sans);
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  display: flex;
  flex-direction: column;
  height: 100vh;
  overflow: hidden;
}

/* On marketing pages, release the locked app shell so the page scrolls
   naturally and the marketing background/footer can extend full height. */
html.marketing-mode,
body.marketing-mode {
  height: auto !important;
  min-height: 100vh;
  overflow: visible !important;
}

#app.marketing-mode {
  height: auto;
  min-height: 100vh;
  overflow: visible;
  text-align: left;
  color: inherit;
}
</style>
